import { hookstate } from "@hookstate/core";

export const PartnersState = hookstate([]);
